/**
 * POST Company
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';

import {
  ACTION_DELETE_CREDITCARD,
  ACTION_DELETE_CREDITCARD_SUCCESS,
  ACTION_DELETE_CREDITCARD_FAILURE,
  ACTION_RESET_DELETE_CREDITCARD,
  API_CALL,
} from '../../configs/ActionTypes';

import { track } from '../../analytics/analytics';
import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function deleteCC(creditCardId: any, type: any) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `creditCards/${creditCardId}`,
        method: 'delete',
        success: (response: object) => {
          dispatch(requestSuccess(response));
          handleTrack(type);
          enqueueSnackbarHandler(
            dispatch,
            { deleteCreditCardSuccess: true },
            'success',
          );
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_DELETE_CREDITCARD,
    payload: null,
  };
}

export function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_DELETE_CREDITCARD_SUCCESS,
    payload: responeJSON,
  };
}

export function requestFailed(responeJSON: object) {
  return {
    type: ACTION_DELETE_CREDITCARD_FAILURE,
    payload: responeJSON,
  };
}

export function resetDeleteCreditCardStatus() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_RESET_DELETE_CREDITCARD,
      payload: null,
    });
  };
}

function handleTrack(type: any) {
  let properties = {
    Type: type,
  };

  track('BB_CreditCardDeleted', properties);
}
